import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import {
  CompaniesHouseAccounts,
  CompaniesHouseChanges,
  CompaniesHouseCompany,
  CompaniesHouseDeadlines,
  CompaniesHouseFilings,
  CompaniesHouseHeaderActions,
  CompaniesHouseNotConnected,
  CompaniesHouseNotice,
  CompaniesHouseOfficers,
  CompaniesHousePscs,
} from "@/features/sources/components/companies-house-sections"
import { companiesHouseQueries } from "@/queries/companies-house"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/sources/companies_house/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      companiesHouseQueries.forFirm(params.firmId)
    ),
  component: FirmCompaniesHousePage,
})

function FirmCompaniesHousePage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Companies House"
        actions={<CompaniesHouseHeaderActions firmId={firmId} />}
      />
      <PageContent>
        <CompaniesHouseNotConnected firmId={firmId} />
        <CompaniesHouseNotice firmId={firmId} />
        <CompaniesHouseCompany firmId={firmId} />
        <CompaniesHouseDeadlines firmId={firmId} />
        <CompaniesHouseChanges firmId={firmId} />
        <CompaniesHouseOfficers firmId={firmId} />
        <CompaniesHousePscs firmId={firmId} />
        <CompaniesHouseAccounts firmId={firmId} />
        <CompaniesHouseFilings firmId={firmId} />
      </PageContent>
    </>
  )
}
